export class FileNameData {
    fileName: string;
    fileBase64: string;
    alreadyStored = false;
    willBeDeleted = false;
    recordId: number;

    constructor(fileName, fileBase64) {
        this.fileName = fileName;
        this.fileBase64 = fileBase64;
    }
}